/* BSD Premium Cart CRO V3 - structural enhancement layer over Atelier cart. Combined-preview stability guard 2026-09-10. */
(function () {
  if (window.BSDCartCroLoaded) return;
  window.BSDCartCroLoaded = true;
  var scheduled = false;

  function money(cents) {
    cents = Math.max(0, Math.round(Number(cents) || 0));
    return '$' + (cents / 100).toLocaleString('en-AU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function setHtml(el, html) {
    if (!el) return;
    var template = document.createElement('template');
    template.innerHTML = html;
    var normalized = template.innerHTML;
    if (el.innerHTML !== normalized) el.innerHTML = normalized;
  }

  function cartTotalCents(drawer) {
    var subtotal = 0;
    drawer.querySelectorAll('.ct-item').forEach(function (item) {
      var quantity = parseInt(item.getAttribute('data-qty'), 10) || 0;
      var unitPrice = Number(item.getAttribute('data-unit-price')) || 0;
      subtotal += quantity * unitPrice;
    });

    var discounts = 0;
    drawer.querySelectorAll('[data-ct-disc-row],[data-ct-auto-row],[data-ct-tier-row]').forEach(function (row) {
      discounts += Number(row.getAttribute('data-disc')) || 0;
    });

    return Math.max(0, subtotal - Math.min(subtotal, discounts));
  }

  function shippingQuote(drawer) {
    var ship = drawer.querySelector('#AtelierShip');
    var priceEl = drawer.querySelector('#AtelierShipRes .ct-ship-rprice');
    if (!ship) return null;
    /* Port note (BSD, 2026-09-11): FIRST quote in flight (no result on screen yet)
       reports a PENDING quote, so the summary shows the row as "Calculating"
       instead of letting the total jump unannounced when the carrier answers.
       The postcode comes from the field the base JS fills at quote start
       ("Suburb, ST 5019"). */
    if (!ship.classList.contains('done') || !priceEl) {
      if (!ship.classList.contains('loading')) return null;
      var q = drawer.querySelector('#AtelierShipQ');
      var pm = q && q.value.match(/(\d{4})\s*$/);
      return { pending: true, cents: 0, free: false, updating: false, postcode: pm ? pm[1] : '', display: '' };
    }

    var raw = (priceEl.textContent || '').trim();
    var free = /free/i.test(raw);
    var numeric = free ? 0 : parseFloat(raw.replace(/[^0-9.]/g, ''));
    if (!free && !isFinite(numeric)) return null;

    var postcode = '';
    var strong = drawer.querySelector('#AtelierShipRes .ct-ship-rtxt b');
    var match = strong && strong.textContent.match(/\b(\d{4})\b/);
    if (match) postcode = match[1];

    return {
      cents: free ? 0 : Math.round(numeric * 100),
      updating: ship.classList.contains('stale'),
      free: free,
      postcode: postcode,
      display: free ? 'FREE' : money(Math.round(numeric * 100))
    };
  }

  function moveUtilities(drawer) {
    var body = drawer.querySelector('.ct-body');
    var tools = drawer.querySelector('.ct-tools');
    var wrap = drawer.querySelector('#AtelierToolWrap');
    if (!body || !tools || !wrap) return;

    var options = body.querySelector('.cro-cart-options');
    if (!options) {
      options = document.createElement('div');
      options.className = 'cro-cart-options';
      var note = body.querySelector('#AtelierCartNote');
      if (note) body.insertBefore(options, note);
      else body.appendChild(options);
    }

    /* contains(), not parentNode: the accordion below parks the wrap INSIDE .ct-tools */
    if (!options.contains(tools)) options.appendChild(tools);
    if (!options.contains(wrap)) options.appendChild(wrap);
  }

  /* Port note (BSD, 2026-09-11, Chris): the open panel must sit directly under
     ITS row - with both rows stacked and one shared panel wrap after them, an
     open delivery panel rendered under "Add discount code". The wrap now moves
     to follow the active row: on the click's CAPTURE phase (before the base
     handler flips .open, so the grid-rows transition still plays) and again
     from enhance() as a safety net. The base JS finds the wrap by id and the
     rows by class, so where they sit does not matter to it. */
  function placeWrap(drawer, tool) {
    var wrap = drawer.querySelector('#AtelierToolWrap');
    if (!wrap || !tool || tool.nextElementSibling === wrap) return;
    tool.insertAdjacentElement('afterend', wrap);
  }
  function bindAccordion(drawer) {
    if (drawer.getAttribute('data-cro-acc') === '1') return;
    drawer.setAttribute('data-cro-acc', '1');
    drawer.addEventListener('click', function (e) {
      var tool = e.target.closest('.ct-tool');
      if (tool && !tool.classList.contains('on')) placeWrap(drawer, tool);
    }, true);
  }

  function checkoutLock(drawer) {
    var icon = drawer.querySelector('#AtelierCheckout svg');
    if (!icon || icon.getAttribute('data-cro-lock') === '1') return;
    icon.setAttribute('data-cro-lock', '1');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.innerHTML = '<rect x="5" y="10" width="14" height="10" rx="1.5"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>';
  }

  function ensureTrust(drawer) {
    var checkout = drawer.querySelector('#AtelierCheckout');
    if (!checkout) return;

    var strip = drawer.querySelector('.cro-trust-strip');
    if (!strip) {
      strip = document.createElement('div');
      strip.className = 'cro-trust-strip';
      strip.setAttribute('aria-label', 'Shopping reassurance');
      strip.innerHTML =
        '<div class="cro-trust-item">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="1.5"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>' +
          '<strong>Secure checkout</strong><span>Protected payment</span>' +
        '</div>' +
        '<div class="cro-trust-item">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7h10v10H7z"/><path d="M8 3 4 7l4 4"/><path d="M4 7h7"/><path d="M16 21l4-4-4-4"/><path d="M20 17h-7"/></svg>' +
          '<strong><a href="/pages/return-and-refund-policy" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;text-underline-offset:2px">Returns policy</a></strong><span>Check eligibility</span>' +
        '</div>' +
        '<div class="cro-trust-item">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="18" cy="18" r="1.6"/></svg>' +
          '<strong>Australia-wide</strong><span>Delivery available</span>' +
        '</div>';
      checkout.insertAdjacentElement('afterend', strip);
    }
  }

  function updateSummary(drawer) {
    var summary = drawer.querySelector('[data-ct-summary]');
    var totalRow = summary && summary.querySelector('.ct-tot');
    var totalLabel = totalRow && totalRow.querySelector('.lbl');
    var totalValue = totalRow && totalRow.querySelector('.val');
    if (!summary || !totalRow) return;

    /* Port note (BSD, 2026-09-11): goods total = the base layer's own figure. The
       snippet stamps cart.total_price (server truth) on .ct-tot .val as data-cents
       and the base recompute keeps it current between round-trips. Re-summing
       qty x unit price here drifted by rounding on discounted multi-qty lines
       (Shopify rounds the per-unit price), so that is now the fallback only. */
    var baseTotal = totalValue && totalValue.hasAttribute('data-cents') ? (+totalValue.getAttribute('data-cents') || 0) : cartTotalCents(drawer);
    var quote = shippingQuote(drawer);
    var deliveryRow = summary.querySelector('.cro-delivery-row');

    var subLabel = summary.querySelector('.ct-sub .lbl');
    setText(subLabel, 'Subtotal');

    if (quote) {
      if (!deliveryRow) {
        deliveryRow = document.createElement('div');
        deliveryRow.className = 'cro-delivery-row';
        totalRow.parentNode.insertBefore(deliveryRow, totalRow);
      }
      var label = 'Delivery' + (quote.postcode ? ' to ' + quote.postcode : '');
      /* Port note (BSD, 2026-09-11): the base JS now re-prices the estimate after
         every cart change and flags the old figure .stale while the carrier
         answers - shown here as "Updating" (the total keeps the previous delivery
         until the new one lands), and a CHANGED figure lands with .just-on. */
      var prevCents = deliveryRow.getAttribute('data-cents');
      setHtml(deliveryRow,
        '<span class="cro-delivery-label">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="18" cy="18" r="1.6"/></svg>' +
          '<span>' + label + '</span>' +
        '</span>' +
        (quote.pending
          ? '<b class="updating">Calculating…</b>'
          : quote.updating
            ? '<b class="updating">Updating…</b>'
            : '<b' + (quote.free ? ' class="free"' : '') + '>' + quote.display + '</b>')
      );
      if (quote.pending) {
        deliveryRow.setAttribute('data-cents', 'pending');   // so the first real figure lands with .just-on
      } else if (!quote.updating) {
        if (prevCents !== null && prevCents !== String(quote.cents)) {
          deliveryRow.classList.add('just-on');
          setTimeout(function () { deliveryRow.classList.remove('just-on'); }, 1200);
        }
        deliveryRow.setAttribute('data-cents', String(quote.cents));
      }
      /* Port note (BSD, 2026-10-06, Chris): while delivery is being (re)priced the
         total shows the goods figure at once - exact, it follows the tap - and says
         plainly that delivery is not in it yet ("Total before delivery"). It used to
         carry the previous delivery until the new one landed: a stale figure. The
         wait line pulses with the delivery row's "Updating" (.cro-tot-wait). */
      var waiting = quote.pending || quote.updating;
      totalRow.classList.toggle('cro-tot-wait', !!waiting);
      setHtml(totalLabel, waiting
        ? 'Total before delivery<small>Delivery' + (quote.postcode ? ' to ' + quote.postcode : '') + (quote.pending ? ' calculating' : ' updating') + '…</small>'
        : 'Estimated total<small>Includes estimated delivery' + (quote.postcode ? ' to ' + quote.postcode : '') + '</small>');
      setText(totalValue, money(baseTotal + (waiting ? 0 : quote.cents)));
    } else {
      if (deliveryRow) deliveryRow.remove();
      totalRow.classList.remove('cro-tot-wait');
      setHtml(totalLabel, 'Estimated total<small>Delivery calculated from your postcode</small>');
      setText(totalValue, money(baseTotal));
    }
  }

  function enhance() {
    scheduled = false;
    var drawer = document.getElementById('AtelierCart');
    if (!drawer) return;

    moveUtilities(drawer);
    bindAccordion(drawer);
    var onTool = drawer.querySelector('.ct-tool.on');
    if (onTool) placeWrap(drawer, onTool);
    checkoutLock(drawer);
    ensureTrust(drawer);
    updateSummary(drawer);

    var oldTitle = drawer.querySelector('.cro-summary-title');
    if (oldTitle) oldTitle.remove();

    var ship = drawer.querySelector('#AtelierShip');
    var shipLabel = drawer.querySelector('#AtelierShipLbl');
    var quote = shippingQuote(drawer);
    if (shipLabel) {
      if (quote && quote.pending) setText(shipLabel, quote.postcode ? 'Calculating delivery to ' + quote.postcode + '…' : 'Calculating delivery…');
      else if (quote && quote.updating) setText(shipLabel, 'Updating delivery to ' + (quote.postcode || 'your postcode') + '…');
      else if (quote) setText(shipLabel, 'Delivery to ' + (quote.postcode || 'your postcode') + ' · ' + quote.display);
      else setText(shipLabel, 'Calculate delivery');
    }

    /* Port note (BSD, 2026-09-11): relabel only while NO code is applied - the
       base snippet renders the applied CODE into this label and it must keep
       showing it (the panel behind it is the applied row with Remove). */
    var discLabel = drawer.querySelector('#AtelierDiscLbl');
    if (discLabel && !drawer.querySelector('[data-ct-disc-row]')) setText(discLabel, 'Add discount code');

    var checkout = drawer.querySelector('#AtelierCheckout');
    var checkoutText = checkout && checkout.querySelector('[data-ct-total]');
    setText(checkoutText, 'Secure checkout');
    if (checkout) checkout.setAttribute('aria-label', 'Proceed to secure checkout');
  }

  /* Port note (BSD, 2026-10-06): the base cart calls this right after it redraws or
     recomputes the drawer, so the overlay's labels and delivery-inclusive total land
     in the same frame (the observer below ran it a frame later: Shopify's own "Total /
     Shipping calculated at checkout" flashed on every redraw). */
  window.BSDCartCroEnhance = enhance;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  /* Port note (BSD, 2026-09-11): everything enhance() touches lives inside
     #AtelierCart, which theme.liquid server-renders on every page - so watch
     the drawer alone. The original document-wide subtree + class observer
     re-ran enhance() on every class flip and node append anywhere on the
     site (search palette, card blooms, infinite scroll). Same triggers
     inside the drawer: section re-renders, .done/.on/.is-empty flips, text. */
  function observe() {
    var drawer = document.getElementById('AtelierCart');
    if (!drawer) return;
    new MutationObserver(schedule).observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
})();
